import { render, staticRenderFns } from "./AddInstrumentationsModal.vue?vue&type=template&id=6c8dc498&scoped=true"
import script from "./AddInstrumentationsModal.vue?vue&type=script&lang=js"
export * from "./AddInstrumentationsModal.vue?vue&type=script&lang=js"
import style0 from "./AddInstrumentationsModal.vue?vue&type=style&index=0&id=6c8dc498&prod&scoped=true&scss=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8dc498",
  null
  
)

export default component.exports